export default __webpack_public_path__ + "static/media/online-learning.28984493.svg";